import { useState } from "react";
import { HashLink } from 'react-router-hash-link';
import { Link, useHistory, useLocation } from "react-router-dom";
import Offcanvas from 'react-bootstrap/Offcanvas';
import './header.scss'
const Header = () => {
  const currentYear = new Date().getFullYear();
  const [showsidebar, setShowSidebar] = useState(false);
  const { hash } = useLocation();
  const isActive = (iHash) => hash === iHash;

  const router = useLocation();

  const handleShowSidebar = () => setShowSidebar(true);
  const handleClose = () => setShowSidebar(false);


  return (
    <>
      <section className="main-navbar">
        <div class="custom-container">
          <nav class="navbar navbar-expand-xl">
            <Link class="navbar-brand" to="/">
              <img src="\logo.svg" alt="logoimg" className="logoimg" />
            </Link>
            <button class="navbar-toggler" onClick={handleShowSidebar}>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                  <path d="M1 11H19M1 6H19M1 1H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
            <div class="collapse navbar-collapse mobile-none" id="navbarSupportedContent">
              <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                <li class="nav-item">
                  <Link to="/terms-of-use" className="nav-link" style={router.pathname === "/terms-of-use" || router.pathname === "/" ? { opacity: "1" } : { opacity: "0.6" }}>Terms of Use</Link>
                </li>
                <li class="nav-item">
                  <Link to="/privacy-policy" className="nav-link" style={router.pathname === "/privacy-policy" ? { opacity: "1" } : { opacity: "0.6" }}>Privacy Policy</Link>
                </li>
                <li class="nav-item">
                  <Link to="/support" className="nav-link" style={router.pathname === "/support" ? { opacity: "1" } : { opacity: "0.6" }}>Support</Link>
                </li>
                <li class="nav-item">
                  <Link to="/account-deletion" className="nav-link" style={router.pathname === "/account-deletion" ? { opacity: "1" } : { opacity: "0.6" }}>Account Deletion</Link>
                </li>

              </ul>

            </div>
          </nav>
        </div>
      </section>
      <div className="mobile-menu">
        <Offcanvas placement="top" show={showsidebar} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <img src="\logo.svg" alt="logoimg" className="logoimg" />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <Link to="/terms-of-use" className="nav-link" style={router.pathname === "/terms-of-use" || router.pathname === "/" ? { opacity: "1" } : { opacity: "0.6" }}>Terms of Use</Link>
              </li>
              <li class="nav-item">
                <Link to="/privacy-policy" className="nav-link" style={router.pathname === "/privacy-policy" ? { opacity: "1" } : { opacity: "0.6" }}>Privacy Policy</Link>
              </li>
              <li class="nav-item">
                <Link to="/support" className="nav-link" style={router.pathname === "/support" ? { opacity: "1" } : { opacity: "0.6" }}>Support</Link>
              </li>
              <li class="nav-item">
                <Link to="/account-deletion" className="nav-link" style={router.pathname === "/account-deletion" ? { opacity: "1" } : { opacity: "0.6" }}>Account Deletion</Link>
              </li>
            </ul>

          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  )
}

export default Header